document.addEventListener('DOMContentLoaded', function() {

    const cards = document.querySelectorAll('.cvlg-cell');
    const cardsPerPage = 9;
    let currentPage = 1;
    const totalPages = Math.ceil(cards.length / cardsPerPage);
    const prevBtn = document.getElementById('cvlg-prev');
    const nextBtn = document.getElementById('cvlg-next');
    const currentPageEl = document.getElementById('cvlg-current-page');
    const totalPagesEl = document.getElementById('cvlg-total-pages');

    if (prevBtn && nextBtn && currentPageEl && totalPagesEl) {
        totalPagesEl.textContent = totalPages;
        function renderPage() {
            const start = (currentPage - 1) * cardsPerPage;
            const end = start + cardsPerPage;
            cards.forEach((card, index) => {
                card.style.display =
                    index >= start && index < end ? 'block' : 'none';
            });
            currentPageEl.textContent = currentPage;
            prevBtn.disabled = currentPage === 1;
            nextBtn.disabled = currentPage === totalPages;
        }
        prevBtn.addEventListener('click', function() {
            if (currentPage > 1) {
                currentPage--;
                renderPage();
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        });
        nextBtn.addEventListener('click', function() {
            if (currentPage < totalPages) {
                currentPage++;
                renderPage();
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        });
        renderPage();
    }
    else {
        cards.forEach(card => {
            card.style.display = 'block';
        });
    }
    const cardsWithBio = document.querySelectorAll('.cvlg-cell.has-bio');
    const popup = document.querySelector('.cvlg-popup');
    const popupOverlay = document.querySelector('.cvlg-popup-overlay');
    const popupClose = document.querySelector('.popup-close');
    const body = document.body;
    const slides = document.querySelectorAll('.cvlg-popup-slide');
    let activeCard = null;
    
    cardsWithBio.forEach(card => {
        card.addEventListener('click', function() {
            const targetId = this.getAttribute('data-href');
            if (!targetId) {return;}
            if (activeCard) {
                activeCard.classList.remove('active-popup');
            }
            this.classList.add('active-popup');
            activeCard = this;
            popup.classList.add('active');
            body.classList.add('custom-scroll');
            slides.forEach(slide => {
                slide.classList.remove('active');
                if (slide.getAttribute('data-id') === targetId) {
                    slide.classList.add('active');
                }
            });
        });
    });
    function closePopup() {
        popup.classList.remove('active');
        body.classList.remove('custom-scroll');
        if (activeCard) {
            activeCard.classList.remove('active-popup');
            activeCard = null;
        }
    }
    popupClose.addEventListener('click', closePopup);
    popupOverlay.addEventListener('click', closePopup);
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
            closePopup();
        }
    });
});
